import { render } from "./SideMenuArea.vue?vue&type=template&id=4c76af1c&scoped=true"
import script from "./SideMenuArea.vue?vue&type=script&lang=js"
export * from "./SideMenuArea.vue?vue&type=script&lang=js"

import "./SideMenuArea.vue?vue&type=style&index=0&id=4c76af1c&scoped=true&lang=stylus"

import exportComponent from "D:\\tokyo-shoseki_R7\\07j\\m\\2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c76af1c"]])

export default __exports__